import { DefaultSeoProps, OrganizationJsonLdProps } from 'next-seo';
import { CURRENT_ENVIRONMENT_URL } from '@/utils/constants';

export const defaultSeo: DefaultSeoProps = {
  description: 'O ecossistema completo da construção civil!',
  openGraph: {
    type: 'website',
    locale: 'pt_BR',
    url: CURRENT_ENVIRONMENT_URL,
    title: 'Obra Play',
    siteName: 'Obra Play',
    description: 'O ecossistema completo da construção civil!',
    images: [
      {
        url: `${CURRENT_ENVIRONMENT_URL}/icons/apple-touch-icon.png"`,
        alt: 'Obra Play logo',
      },
    ],
  },
  twitter: {
    cardType: 'summary_large_image',
  },
};

export const defaultOrganizationJson: OrganizationJsonLdProps = {
  id: 'obra-play-organization',
  logo: `${CURRENT_ENVIRONMENT_URL}/icons/apple-touch-icon.png"`,
  image: [`${CURRENT_ENVIRONMENT_URL}/icons/apple-touch-icon.png"`],
  url: CURRENT_ENVIRONMENT_URL,
  sameAs: ['https://www.obraplay.com/'],
  name: 'Obra Play',
  legalName: 'Obra Play',
  description:
    'O Obra Play é uma plataforma para todos os envolvidos da construção civil. Solicite orçamentos, candidate-se a vagas, encontre fornecedores e profissionais bem avaliados.',
  slogan: 'O ecossistema completo da Construção civil!',
  contactPoint: [
    {
      telephone: '(41) 9 9630-6909',
      contactType: 'Serviço do consumidor',
      email: 'contato@obraplay.com',
      areaServed: 'BR',
    },
  ],
  email: 'contato@obraplay.com',
  telephone: '(41) 9 9630-6909',
};
